import { applyMaskBrlCurrencyFloat } from '@/view/utils/formatCurrency'
import { productForm } from '@/view/validators/product-validator'
import { useEffect } from 'react'
import { NumericFormat } from 'react-number-format'
import { useSearchParams } from 'react-router-dom'
import { useLocalStorage } from '../../../../../remote/local-storage'
import { ComboSelectWithLabel } from '../../../../components/combo-select-with-label'
import { Button } from '../../../../components/ui/button'
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from '../../../../components/ui/form'
import { Input } from '../../../../components/ui/input'
import { Label } from '../../../../components/ui/label'
import { Switch } from '../../../../components/ui/switch'
import { Textarea } from '../../../../components/ui/textarea'
import { CreateProduct } from '../actions/products/create-product'
import { LoadCategoryProduct } from '../actions/products/load-categoria'
import { LoadCostCenter } from '../actions/products/load-cost-center'
import { LoadProductId } from '../actions/products/load-product-id'

type RegisterProductProps = {
  id: string
}

export function RegisterProduct({ id }: RegisterProductProps) {
  const [params] = useSearchParams()
  const { getUnitId } = useLocalStorage()
  const { form, onSubmit } = CreateProduct()
  const { data: costCenter } = LoadCostCenter()
  const { data: categoryProduto } = LoadCategoryProduct()
  const { load } = LoadProductId()
  const isEditMode = Boolean(id)

  const fetchProductId = async () => {
    const response: productForm = await load(id)
    if (response && costCenter?.length && categoryProduto?.length) {
      form.setValue('id', response?.id || '')
      form.setValue('nome', response?.nome || '')
      form.setValue('descricao', response?.descricao || '')
      form.setValue('categoriaProduto.id', response?.categoriaProduto?.id)
      form.setValue('centroCusto.id', response?.centroCusto?.id)
      form.setValue('valor', applyMaskBrlCurrencyFloat(response?.valor) || '0')
      form.setValue('valorCusto', applyMaskBrlCurrencyFloat(response?.valorCusto) || '0')
      form.setValue('valorComissao', applyMaskBrlCurrencyFloat(response?.valorComissao) || '0')
      form.setValue('valorDesconto', applyMaskBrlCurrencyFloat(response?.valorDesconto) || '0')
      form.setValue('quantidadeEstoque', response?.quantidadeEstoque || 0)
      form.setValue('tipoComissao', response?.tipoComissao || 'VALOR_FIXO')
      form.setValue('vendaOnline', response?.vendaOnline)
      form.setValue('unidade.id', response?.unidade?.id || 0)
    }
  }

  useEffect(() => {
    if (isEditMode && costCenter?.length && categoryProduto?.length) {
      fetchProductId()
    }
  }, [id, costCenter, categoryProduto, isEditMode])

  useEffect(() => {
    form.setValue('unidade.id', getUnitId())
  }, [params])

  const formValues = form.watch()

  useEffect(() => {
    console.log(formValues)
  }, [formValues])

  const {
    formState: { errors }
  } = form

  useEffect(() => {
    console.log('Erros do formulário:', errors)
  }, [errors])

  return (
    <div className="">
      <Form {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)} className="flex flex-col gap-2">
          <div className="grid grid-cols-2 gap-2">
            <FormField
              control={form.control}
              name="nome"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>
                    <span className="text-gray-400">*</span>
                    Nome
                  </FormLabel>
                  <FormControl>
                    <Input {...field} />
                  </FormControl>
                  <FormMessage className="text-xs">{form.formState.errors?.nome?.message}</FormMessage>
                </FormItem>
              )}
            />
          </div>

          <FormField
            control={form.control}
            name="descricao"
            render={({ field }) => (
              <FormItem>
                <FormLabel>
                  <span className="text-gray-400"></span>
                  Observação
                </FormLabel>
                <FormControl>
                  <Textarea {...field}></Textarea>
                </FormControl>
                <FormMessage className="text-xs">{form.formState.errors?.descricao?.message}</FormMessage>
              </FormItem>
            )}
          />
          <div className="grid grid-cols-2 gap-2">
            <FormField
              control={form.control}
              name="categoriaProduto.id"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>
                    <span className="text-gray-400">*</span>
                    Categoria produto
                  </FormLabel>
                  <FormControl>
                    <ComboSelectWithLabel defaultValue={field.value} data={categoryProduto || []} onChange={(e) => field.onChange(e.value)} />
                  </FormControl>
                  <FormMessage className="text-xs">{form.formState.errors?.categoriaProduto?.id?.message}</FormMessage>
                </FormItem>
              )}
            />

            <FormField
              control={form.control}
              name="centroCusto.id"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>
                    <span className="text-gray-400">*</span>
                    Centro de custo
                  </FormLabel>
                  <FormControl>
                    <ComboSelectWithLabel defaultValue={field.value} data={costCenter || []} onChange={(e) => field.onChange(e.value)} />
                  </FormControl>
                  <FormMessage className="text-xs">{form.formState.errors?.centroCusto?.id?.message}</FormMessage>
                </FormItem>
              )}
            />
          </div>
          <div className="grid grid-cols-4 gap-2">
            <FormField
              control={form.control}
              name="valor"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>
                    <span className="text-gray-400">*</span>
                    Valor
                  </FormLabel>
                  <FormControl>
                    <NumericFormat
                      className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
                      thousandSeparator="."
                      decimalSeparator=","
                      prefix="R$ "
                      decimalScale={2}
                      getInputRef={field.ref}
                      {...field}
                      fixedDecimalScale={true}
                    />
                  </FormControl>
                  <FormMessage className="text-xs">{form.formState.errors?.valor?.message}</FormMessage>
                </FormItem>
              )}
            />

            <FormField
              control={form.control}
              name="valorCusto"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>
                    <span className="text-gray-400">*</span>
                    Valor de custo
                  </FormLabel>
                  <FormControl>
                    <NumericFormat
                      className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
                      thousandSeparator="."
                      decimalSeparator=","
                      prefix="R$ "
                      decimalScale={2}
                      getInputRef={field.ref}
                      {...field}
                      fixedDecimalScale={true}
                    />
                  </FormControl>
                  <FormMessage className="text-xs">{form.formState.errors?.valorCusto?.message}</FormMessage>
                </FormItem>
              )}
            />

            <FormField
              control={form.control}
              name="valorComissao"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>
                    <span className="text-gray-400"></span>
                    Valor de comissão
                  </FormLabel>
                  <FormControl>
                    <NumericFormat
                      className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
                      thousandSeparator="."
                      decimalSeparator=","
                      prefix="R$ "
                      decimalScale={2}
                      getInputRef={field.ref}
                      {...field}
                      fixedDecimalScale={true}
                    />
                  </FormControl>
                  <FormMessage className="text-xs">{form.formState.errors?.valorComissao?.message}</FormMessage>
                </FormItem>
              )}
            />

            <FormField
              control={form.control}
              name="valorDesconto"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>
                    <span className="text-gray-400"></span>
                    Valor de desconto
                  </FormLabel>
                  <FormControl>
                    <NumericFormat
                      className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
                      thousandSeparator="."
                      decimalSeparator=","
                      prefix="R$ "
                      decimalScale={2}
                      getInputRef={field.ref}
                      {...field}
                      fixedDecimalScale={true}
                    />
                  </FormControl>
                  <FormMessage className="text-xs">{form.formState.errors?.valorDesconto?.message}</FormMessage>
                </FormItem>
              )}
            />
          </div>
          <div className="grid grid-cols-4 gap-2">
            <FormField
              control={form.control}
              name="quantidadeEstoque"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>
                    <span className="text-gray-400 w-8">*</span>
                    Quantidade em estoque
                  </FormLabel>
                  <FormControl>
                    <Input
                      {...field}
                      type="number"
                      min={0}
                      onChange={(e) => {
                        const value = e.target.value
                        field.onChange(value ? parseInt(value, 10) : 0)
                      }}
                    />
                  </FormControl>
                  <FormMessage className="text-xs">{form.formState.errors?.quantidadeEstoque?.message}</FormMessage>
                </FormItem>
              )}
            />
            {/* <FormField
              control={form.control}
              name="tipoComissao"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>
                    <span className="text-gray-400">*</span>
                    Tipo de comissão
                  </FormLabel>
                  <CustomSelect onValueChange={field.onChange} defaultValue={field.value}>
                    <FormControl>
                      <SelectTrigger>
                        <SelectValue placeholder="Selecione..." />
                      </SelectTrigger>
                    </FormControl>
                    <SelectContent>
                      <SelectItem value="PERCENTUAL">Porcentual</SelectItem>
                      <SelectItem value="VALOR_FIXO">Valor Fixo</SelectItem>
                    </SelectContent>
                  </CustomSelect>
                  <FormMessage className="text-xs">{form.formState.errors?.tipoComissao?.message}</FormMessage>
                </FormItem>
              )}
            /> */}
            <div className="flex items-center pt-8">
              <FormField
                control={form.control}
                name="vendaOnline"
                render={({ field }) => (
                  <FormItem>
                    <FormControl>
                      <div className="flex items-center">
                        <Label className="flex gap-2 items-center ">
                          Venda online?
                          <Switch onCheckedChange={field.onChange} checked={field.value} />
                        </Label>
                      </div>
                    </FormControl>
                    <FormMessage className="text-xs">{form.formState.errors?.vendaOnline?.message}</FormMessage>
                  </FormItem>
                )}
              />
            </div>
          </div>

          {/* TODO: <p>verificar "tipo comissao", "categoria" "centro de receita?" </p> */}

          <Button type="submit" className="bg-acelerafit-green-400 text-muted hover:bg-cashfit-green-200">
            Enviar
          </Button>
        </form>
      </Form>
    </div>
  )
}
